export namespace ChartUtils {
  export function mean(values: number[]): number | null {
    const nums = values.filter((v) => Number.isFinite(v));
    if (!nums.length) return null;
    return nums.reduce((a, b) => a + b, 0) / nums.length;
  }

  export function withAlpha(hex: string, a = 0.3) {
    return `rgba(${parseInt(hex.slice(1, 3), 16)},${parseInt(hex.slice(3, 5), 16)},${parseInt(
      hex.slice(5, 7),
      16
    )},${a})`;
  }
}
